<template>
  <SideMenu :visible="visible" @close="$emit('close')">
    <InfoModal
      v-if="documentsInfoTextVisible && applicationIsEditable"
      class="documents-info-modal"
      title="Den här kategorin är låst"
      @click="documentsInfoTextVisible = false"
    >
      <p>
        För att kunna ladda upp filer behöver du ange ett <b>skäl</b> för
        andrahandsuthyrning.
      </p>
      <BaseButton
        :is-loading="false"
        :is-rounded="true"
        :is-fullwidth="isMobile"
        :is-small="isMobile"
        type="button"
        @click="closeModalAndRedirectToReason"
        ><BaseIconText :icon-url="svgs.ICONS.ARROW_RIGHT" :align-right="true">
          Ange skäl
        </BaseIconText>
      </BaseButton>
    </InfoModal>
    <InfoModal
      v-if="showDisabledOvInfo"
      class="documents-info-modal"
      title="Den här kategorin är låst"
      abort-label="Stäng"
      @click="showDisabledOvInfo = false"
    >
      <p>Den här kategorin kommer den andra parten att fylla i.</p>
    </InfoModal>
    <template v-for="item in sideMenu">
      <ul :key="item.label" class="sublet-links">
        <SideMenuLink
          :key="item.url"
          :enabled="item.enabled"
          :url="item.url"
          :show-status="false"
          :is-swap-menu="false"
          @click="
            $emit('close');
            handleDocumentsInfoTextVisible(item.statusName, item.enabled);
          "
        >
          {{ item.label }}
        </SideMenuLink>
      </ul>
    </template>
    <section class="buttons">
      <BaseButton
        v-if="isMobile"
        :is-rounded="true"
        :is-default="true"
        :is-fullwidth="true"
        :is-small="isMobile"
        @click="$emit('logout')"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.59 11L8.29 13.29C8.19627 13.383 8.12188 13.4936 8.07111 13.6154C8.02034 13.7373 7.9942 13.868 7.9942 14C7.9942 14.132 8.02034 14.2627 8.07111 14.3846C8.12188 14.5064 8.19627 14.617 8.29 14.71C8.38296 14.8037 8.49356 14.8781 8.61542 14.9289C8.73728 14.9797 8.86799 15.0058 9 15.0058C9.13201 15.0058 9.26272 14.9797 9.38458 14.9289C9.50644 14.8781 9.61704 14.8037 9.71 14.71L13.71 10.71C13.801 10.6149 13.8724 10.5028 13.92 10.38C14.02 10.1365 14.02 9.86347 13.92 9.62001C13.8724 9.49726 13.801 9.38511 13.71 9.29001L9.71 5.29001C9.61676 5.19677 9.50607 5.12281 9.38425 5.07235C9.26243 5.02189 9.13186 4.99592 9 4.99592C8.86814 4.99592 8.73757 5.02189 8.61575 5.07235C8.49393 5.12281 8.38324 5.19677 8.29 5.29001C8.19676 5.38325 8.1228 5.49394 8.07234 5.61576C8.02188 5.73758 7.99591 5.86815 7.99591 6.00001C7.99591 6.13187 8.02188 6.26244 8.07234 6.38426C8.1228 6.50608 8.19676 6.61677 8.29 6.71001L10.59 9.00001H1C0.734784 9.00001 0.48043 9.10537 0.292893 9.2929C0.105357 9.48044 0 9.73479 0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8947 0.734784 11 1 11H10.59ZM10 8.14093e-06C8.13109 -0.00833565 6.29724 0.507221 4.70647 1.4882C3.11569 2.46918 1.83165 3.87632 1 5.55001C0.880653 5.7887 0.861015 6.06503 0.945406 6.31821C1.0298 6.57138 1.21131 6.78066 1.45 6.90001C1.68869 7.01936 1.96502 7.03899 2.2182 6.9546C2.47137 6.87021 2.68065 6.6887 2.8 6.45001C3.43219 5.17333 4.39383 4.08863 5.58555 3.308C6.77727 2.52736 8.15582 2.07913 9.57876 2.0096C11.0017 1.94007 12.4174 2.25178 13.6795 2.91252C14.9417 3.57325 16.0045 4.55904 16.7581 5.768C17.5118 6.97697 17.9289 8.36526 17.9664 9.78939C18.0039 11.2135 17.6605 12.6219 16.9715 13.8688C16.2826 15.1158 15.2731 16.1562 14.0475 16.8824C12.8219 17.6087 11.4246 17.9945 10 18C8.50888 18.0065 7.04615 17.5924 5.77969 16.8053C4.51323 16.0181 3.49435 14.8899 2.84 13.55C2.72065 13.3113 2.51137 13.1298 2.2582 13.0454C2.00502 12.961 1.72869 12.9807 1.49 13.1C1.25131 13.2194 1.0698 13.4286 0.985406 13.6818C0.901015 13.935 0.920653 14.2113 1.04 14.45C1.83283 16.0455 3.03752 17.4002 4.52947 18.3741C6.02142 19.3479 7.74645 19.9054 9.52612 19.989C11.3058 20.0726 13.0755 19.6792 14.6521 18.8495C16.2288 18.0198 17.5552 16.784 18.4941 15.2698C19.433 13.7557 19.9503 12.0181 19.9925 10.237C20.0347 8.45588 19.6003 6.6958 18.7342 5.13884C17.8682 3.58188 16.6018 2.28457 15.0663 1.38111C13.5307 0.477653 11.7816 0.000844593 10 8.14093e-06Z"
            fill="#878B9D"
          />
        </svg>
        <span class="button-text">Logga ut</span>
      </BaseButton>
    </section>
    <!-- 
          <button class="privacy-policy" @click="termsModalVisible = true">
            Personuppgiftshantering
          </button> --></SideMenu
  >
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SideMenu from '@/components/SideMenu/SideMenu.vue';
import SideMenuLink from '@/components/SideMenu/SideMenuLink.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIconText from '@/components/BaseIconText.vue';
import InfoModal from '@/components/InfoModal.vue';
import svgs from '@/utils/icon-constants';

export default {
  components: { SideMenu, SideMenuLink, BaseButton, InfoModal, BaseIconText },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      documentsInfoTextVisible: false,
      svgs,
      showDisabledOvInfo: false
    };
  },

  computed: {
    ...mapState({
      subletApplication: state => state.subletApplication.application
    }),
    ...mapGetters({
      isMobile: 'app/isMobile',
      applicationIsEditable: 'subletApplication/applicationIsEditable',
      sideMenu: 'subletApplication/sideMenu'
    })
  },
  methods: {
    handleDocumentsInfoTextVisible(formType, enabled) {
      if (formType === 'DOCUMENTS' && !enabled) {
        this.documentsInfoTextVisible = true;
      }
      if (formType === 'SUBTENANT_INFORMATION' && !enabled) {
        this.showDisabledOvInfo = true;
      }
    },
    closeModalAndRedirectToReason() {
      this.documentsInfoTextVisible = false;

      this.$router.push('/skal');
    }
  }
};
</script>
<style lang="scss" scoped>
.sublet-links {
  width: 100%;
  padding: 0;
  margin-top: 10px;
  margin-left: -10px;
}
.button-text {
  display: block;
  margin-left: 15px;
}

.buttons {
  width: 100%;
  padding-right: 20px;
  margin-bottom: 20px;
  > *:nth-child(2) {
    margin-top: 2rem;
  }
}

.privacy-policy,
.skandia-info {
  background: transparent;
  box-shadow: none;
  border: none;
  width: 100%;
  text-decoration: none;
  color: var(--color-gray);
  font-weight: 600;
  font-size: 1.2rem;
  padding: 0.6rem 0;
  display: flex;
  cursor: pointer;
  opacity: 0.8;
  &:hover {
    color: var(--color-blue);
  }
}

.documents-info-modal {
  :deep(.info-modal-body) {
    padding-top: 2.2rem;
    padding-bottom: 2.2rem;
  }

  .go-to-reason-link {
    color: #fff;
    text-decoration: none;

    &:visited {
      color: #fff;
      text-decoration: none;
    }
  }
}
</style>
